import React, { useState } from 'react';
import { useGetAllProductsQuery } from 'api/productApi';
import { useNavigate } from 'react-router-dom';
import { productImageSrc } from 'utils/mediaUrl';

const DisplayProduct = () => {
    const { data: products, isLoading, isError } = useGetAllProductsQuery();
    const navigate = useNavigate();
    const [showAll, setShowAll] = useState(false);

    if (isLoading) return <p className="text-center mt-10 text-blue-500">Loading products...</p>;
    if (isError) return <p className="text-center mt-10 text-red-500">Error loading products</p>;

    const displayedProducts = showAll ? products : products?.slice(0, 5);

    return (
        <div className="p-4 mt-10 md:mt-16 max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                <h2 className="text-2xl font-bold">Create the Products</h2>
                <button
                    className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white py-2 px-6 rounded"
                    onClick={() => {
                        navigate(`/create product`);
                    }}
                >
                    Create Product
                </button>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
                <h2 className="text-xl sm:text-2xl font-semibold">
                    {showAll ? "All Available Products" : "Latest Products"}
                </h2>
                {products?.length > 5 && (
                    <button
                        onClick={() => setShowAll(!showAll)}
                        className="flex items-center gap-2 px-5 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                    >
                        {showAll ? "Show Less" : "View All Products"}
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            className={`h-4 w-4 transition-transform duration-300 ${showAll ? 'rotate-180' : ''}`} 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                )}
            </div>

            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                {displayedProducts?.map((product) => (
                    <div
                        key={product.id}
                        className="border rounded-lg p-4 shadow hover:shadow-md transition flex flex-col h-full"
                    >
                        <div className="flex-grow">
                            <img
                                src={productImageSrc(product)}
                                alt={product.name}
                                className="w-full h-40 object-contain mb-4 bg-gray-50"
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src =
                                        'data:image/svg+xml;charset=UTF-8,' +
                                        encodeURIComponent(
                                            `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200" viewBox="0 0 400 200"><rect fill="#f3f4f6" width="400" height="200"/><text fill="#6b7280" font-family="sans-serif" font-size="18" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">Image unavailable</text></svg>`
                                        );
                                }}
                            />
                            <h3 className="text-lg font-semibold">{product.name}</h3>
                            <p className="text-sm text-gray-500">{product.category}</p>
                            <p className="mt-2 text-gray-700 text-sm">{product.description}</p>

                            <div className="mt-4 space-y-1 text-sm">
                                {product.unit1 && product.price1 && (
                                    <p>
                                        <strong>Unit {product.unit1}:</strong> ₹{product.price1}
                                    </p>
                                )}
                                {product.unit2 && product.price2 && (
                                    <p>
                                        <strong>Unit {product.unit2}:</strong> ₹{product.price2}
                                    </p>
                                )}
                                {product.unit3 && product.price3 && (
                                    <p>
                                        <strong>Unit {product.unit3}:</strong> ₹{product.price3}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="mt-4">
                            <button
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
                                onClick={() => {
                                    navigate(`/product/${product.slug}/`);
                                }}
                            >
                                Manage Product
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DisplayProduct;
